import { getApps, initializeApp, type FirebaseApp, type FirebaseOptions } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

function env(name: keyof ImportMetaEnv): string | undefined {
  const value = import.meta.env[name];
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function readFirebaseConfig(): FirebaseOptions | null {
  const apiKey = env("VITE_FIREBASE_API_KEY");
  const authDomain = env("VITE_FIREBASE_AUTH_DOMAIN");
  const projectId = env("VITE_FIREBASE_PROJECT_ID");

  if (!apiKey || !authDomain || !projectId) {
    return null;
  }

  const config: FirebaseOptions = { apiKey, authDomain, projectId };

  const storageBucket = env("VITE_FIREBASE_STORAGE_BUCKET");
  const messagingSenderId = env("VITE_FIREBASE_MESSAGING_SENDER_ID");
  const appId = env("VITE_FIREBASE_APP_ID");

  if (storageBucket) config.storageBucket = storageBucket;
  if (messagingSenderId) config.messagingSenderId = messagingSenderId;
  if (appId) config.appId = appId;

  return config;
}

export function isFirebaseConfigured(): boolean {
  return readFirebaseConfig() !== null;
}

let app: FirebaseApp | undefined;
let auth: Auth | undefined;

export function getFirebaseAuth(): Auth | null {
  const config = readFirebaseConfig();
  if (!config) {
    return null;
  }

  if (!app) {
    app = getApps().length > 0 ? getApps()[0]! : initializeApp(config);
  }
  if (!auth) {
    auth = getAuth(app);
  }
  return auth;
}
